/**
 * Rubina Irfan — Product Page JS
 * Gallery · Variant Selection + Size Gate · AJAX ATC (+ shawl add-on) · Qty Stepper · Wishlist · Size Modal · Sticky ATC
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────
     Helpers
  ───────────────────────────────────────────── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* This file's local formatMoney was the only correct one in the theme; it now
     lives in ri-money.js so the cart drawer and wishlist page share it rather
     than each carrying a broken copy. Written with innerHTML below, because
     shop.money_format contains markup (<span class=money>…</span>) that has to
     be parsed, not printed. */
  function formatMoney(cents, format) {
    return window.RIMoney.format(cents, format);
  }

  var ADDING_LABEL = 'Adding…';

  /* ─────────────────────────────────────────────
     Initialise on DOMContentLoaded
  ───────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    var productDataEl = qs('#ri-product-data');
    if (!productDataEl) return;

    var productData;
    try { productData = JSON.parse(productDataEl.textContent); } catch (e) { return; }

    var variants    = productData.variants || [];
    var moneyFormat = productData.money_format || '${{amount}}';

    /* ── 1. GALLERY ── */
    initGallery();

    /* ── 2. VARIANT SELECTION + SIZE GATE ── */
    initVariants(variants, moneyFormat);

    /* ── 3. AJAX ATC ── */
    initATC();

    /* ── 3b. BUY NOW ── */
    initBuyNow();

    /* ── 3c. STICKY ATC (mobile) ── */
    initStickyATC();

    /* ── 4. QUANTITY STEPPER ── */
    initQty();

    /* ── 5. WISHLIST ── */
    initWishlist();

    /* ── 6. SIZE MODAL ── */
    initSizeModal();

    /* ── 7. DRAG TO SCROLL (related rows) ── */
    initDragToScroll();
  });

  /* ─────────────────────────────────────────────
     1. GALLERY
  ───────────────────────────────────────────── */
  function initGallery() {
    var thumbsEl   = qs('#ri-thumbs');
    var mainEl     = qs('#ri-main-img');
    var lightbox   = qs('#ri-lightbox');
    var lightboxImg = qs('#ri-lightbox-img');

    if (!thumbsEl || !mainEl) return;

    var thumbs = qsa('.ri-product__thumb', thumbsEl);
    var slides = qsa('.ri-product__slide', mainEl);

    function goTo(index) {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      if (thumbs[index]) thumbs[index].classList.add('is-active');
      if (slides[index]) slides[index].classList.add('is-active');
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(parseInt(btn.dataset.index, 10));
      });
    });

    /* Lightbox */
    if (!lightbox || !lightboxImg) return;

    mainEl.addEventListener('click', function () {
      var activeSlide = qs('.ri-product__slide.is-active', mainEl);
      if (!activeSlide) return;
      var img = qs('img', activeSlide);
      if (!img) return;
      lightboxImg.src = img.src.replace(/width=\d+/, 'width=2000');
      lightboxImg.alt = img.alt;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      qs('.ri-product__lightbox-close', lightbox).focus();
    });

    function closeLightbox() {
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    qs('.ri-product__lightbox-close', lightbox).addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.getAttribute('aria-hidden') === 'false') closeLightbox();
    });

    /* Touch swipe on main image */
    var swipeStartX = 0;
    var swipeStartY = 0;

    function currentIndex() {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    mainEl.addEventListener('touchstart', function (e) {
      swipeStartX = e.touches[0].clientX;
      swipeStartY = e.touches[0].clientY;
    }, { passive: true });
    mainEl.addEventListener('touchend', function (e) {
      var dx = swipeStartX - e.changedTouches[0].clientX;
      var dy = swipeStartY - e.changedTouches[0].clientY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        var idx = currentIndex();
        goTo(dx > 0
          ? (idx < slides.length - 1 ? idx + 1 : 0)
          : (idx > 0 ? idx - 1 : slides.length - 1));
      }
    }, { passive: true });

    /* Expose for variant selection to switch slides */
    window._riGalleryGoTo = goTo;
  }

  /* ─────────────────────────────────────────────
     2. VARIANT SELECTION + SIZE GATE

     Size chips arrive unselected and #ri-variant-id arrives empty (see the size
     gate in ri-product.liquid), so the buttons stay disabled on "Select a size"
     until a size is picked. The gate stands aside when Type is Unstitched: the
     Size group is hidden and ignored, and the variant resolves from the other
     options alone.

     Selections are tracked by option POSITION. The old lookup sorted whatever
     chips happened to be active and compared them to option1..n in order, so
     with the size hidden (or simply not chosen yet) every later option shifted
     one place and matched nothing.
  ───────────────────────────────────────────── */
  function initVariants(variants, moneyFormat) {
    var variantIdEl = qs('#ri-variant-id');
    var atcBtn      = qs('#ri-atc-btn');
    var buyNowBtn   = qs('#ri-buy-now-btn');
    var priceEl     = qs('.ri-product__price');
    var compareEl   = qs('.ri-product__price-compare');
    var availEl     = qs('.ri-product__availability');
    var mtoTemplate = qs('#ri-avail-mto');
    var sizeGroup   = qs('.ri-product__option-group--size');
    var typeGroup   = qs('.ri-product__option-group--type');
    var addonTotal  = qs('[data-addon-total]');

    if (!variantIdEl) return;

    var sizeIndex = sizeGroup ? parseInt(sizeGroup.dataset.optionIndex, 10) : -1;

    function sizeApplies() {
      return !!sizeGroup && !sizeGroup.classList.contains('ri-product__option-group--na');
    }

    /* selected[i] is the value chosen for option i, or null. */
    function getSelectedOptions() {
      var selected = [];
      qsa('.ri-product__option-group').forEach(function (group) {
        var i = parseInt(group.dataset.optionIndex, 10);
        if (isNaN(i)) return;
        var active = qs('.ri-product__swatch.is-active, .ri-product__chip.is-active', group);
        selected[i] = active ? active.dataset.value : null;
      });
      return selected;
    }

    /* Options with no choice yet (or the hidden size) match anything. Among the
       matches an available variant wins, so an unchosen size never makes the
       price or the stock line fall back to a sold-out variant. */
    function findVariant(selected) {
      var matches = variants.filter(function (v) {
        var values = [v.option1, v.option2, v.option3];
        for (var i = 0; i < selected.length; i++) {
          if (selected[i] == null) continue;
          if (i === sizeIndex && !sizeApplies()) continue;
          if (values[i] !== selected[i]) return false;
        }
        return true;
      });
      return matches.filter(function (v) { return v.available; })[0] || matches[0];
    }

    function sizeMissing(selected) {
      return sizeApplies() && sizeIndex > -1 && !selected[sizeIndex];
    }

    /* state: 'add' | 'select' | 'soldout'. data-state is what the sticky bar
       reads, so it is set on every change. */
    function setButtons(state) {
      if (atcBtn) {
        atcBtn.dataset.state = state;
        atcBtn.disabled = state !== 'add';
        atcBtn.textContent = state === 'add' ? atcBtn.dataset.labelAdd
          : state === 'select' ? atcBtn.dataset.labelSelect
          : atcBtn.dataset.labelSoldOut;
      }
      if (buyNowBtn) buyNowBtn.disabled = state !== 'add';
    }

    function updateUI(variant, changedOptionName, missingSize) {
      /* Price */
      /* Fix: shop.money_format can contain HTML (e.g. <span class=money>{{amount}}</span>).
         Assigning that string via textContent renders the tags as literal text instead of
         parsing them, which is what broke the formatting on variant change. Use innerHTML
         so the markup in money_format is actually rendered, matching the server-rendered
         price on initial page load. */
      if (priceEl) {
        priceEl.innerHTML = formatMoney(variant.price, moneyFormat);
        priceEl.classList.toggle('ri-product__price--sale', variant.compare_at_price > variant.price);
      }
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.innerHTML = formatMoney(variant.compare_at_price, moneyFormat);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      /* Savings amount */
      var saveEl = qs('.ri-product__save');
      if (saveEl) {
        if (variant.compare_at_price > variant.price) {
          var savings = variant.compare_at_price - variant.price;
          saveEl.innerHTML = 'Save ' + formatMoney(savings, moneyFormat);
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }

      /* Shawl add-on total follows the garment's price */
      if (addonTotal) {
        var amountEl = qs('[data-addon-total-amount]', addonTotal);
        var shawlPrice = parseInt(addonTotal.dataset.shawlPrice, 10) || 0;
        if (amountEl) amountEl.innerHTML = formatMoney(variant.price + shawlPrice, moneyFormat);
      }

      /* Availability. Made-to-order products restore their lead-time line from
         the server-rendered <template>; everything else keeps In/Out of Stock. */
      if (availEl) {
        if (variant.available && mtoTemplate) {
          availEl.innerHTML = mtoTemplate.innerHTML;
        } else if (variant.available) {
          availEl.innerHTML = '<span class="ri-avail-dot ri-avail-dot--in"></span> In Stock';
        } else {
          availEl.innerHTML = '<span class="ri-avail-dot ri-avail-dot--out"></span> Out of Stock';
        }
      }

      /* Buttons + hidden variant ID. No size, no id: the form cannot add. */
      if (missingSize) {
        setButtons(variant.available ? 'select' : 'soldout');
        variantIdEl.value = '';
      } else {
        setButtons(variant.available ? 'add' : 'soldout');
        variantIdEl.value = variant.id;
      }

      /* Switch gallery to variant image — only for Color/Colour changes with assigned images */
      var isColorChange = changedOptionName && (changedOptionName.toLowerCase() === 'color' || changedOptionName.toLowerCase() === 'colour');
      if (isColorChange && variant.has_featured_image && typeof window._riGalleryGoTo === 'function') {
        window._riGalleryGoTo(variant.featured_image_index);
      }
    }

    function onOptionChange(btn, groupSel) {
      var group = btn.closest('.ri-product__option-group');
      qsa(groupSel, group).forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');

      toggleSizeOption();

      var selected = getSelectedOptions();
      var variant  = findVariant(selected);
      var optionLabel = qs('.ri-product__option-label span', group);
      var optionName = optionLabel ? optionLabel.textContent.trim() : '';

      if (variant) {
        updateUI(variant, optionName, sizeMissing(selected));
      } else {
        /* A combination no variant exists for */
        setButtons('soldout');
        variantIdEl.value = '';
      }
    }

    /* Hide the Size group while Type is Unstitched. The server renders the same
       class from the selected variant, so on load this changes nothing and the
       group never flashes in and out. */
    function toggleSizeOption() {
      if (!typeGroup || !sizeGroup) return;

      var activeChip = qs('.ri-product__chip.is-active', typeGroup) ||
                       qs('.ri-product__swatch.is-active', typeGroup);
      if (!activeChip) return;

      var selectedType = (activeChip.dataset.value || activeChip.textContent || '').trim().toLowerCase();
      sizeGroup.classList.toggle('ri-product__option-group--na', selectedType === 'unstitched');
    }

    qsa('.ri-product__swatch').forEach(function (btn) {
      btn.addEventListener('click', function () { onOptionChange(btn, '.ri-product__swatch'); });
    });
    qsa('.ri-product__chip').forEach(function (btn) {
      btn.addEventListener('click', function () { onOptionChange(btn, '.ri-product__chip'); });
    });
  }

  /* ─────────────────────────────────────────────
     3. AJAX ADD TO CART

     Posts an items array to /cart/add.js: the garment, plus the matching shawl
     when the add-on box is ticked, in ONE request - so either both land in the
     cart or neither does, and the customer is told why (Shopify's description,
     e.g. the shawl just sold out).
  ───────────────────────────────────────────── */
  function cartItems() {
    var variantId = qs('#ri-variant-id');
    var qty       = qs('.ri-qty-input');
    if (!variantId || !variantId.value) return null;

    var quantity = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
    var items = [{ id: parseInt(variantId.value, 10), quantity: quantity }];

    var addon = qs('[data-ri-addon-input]');
    if (addon && addon.checked && !addon.disabled && addon.dataset.variantId) {
      items.push({ id: parseInt(addon.dataset.variantId, 10), quantity: quantity });
    }
    return items;
  }

  function postItems(items) {
    return fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ items: items })
    })
    .then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          var err = new Error('cart_error');
          err.description = data && (data.description || data.message);
          throw err;
        }
        return data;
      });
    });
  }

  function focusSizes() {
    var group = qs('.ri-product__option-group--size');
    if (!group) return;
    group.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var chip = qs('.ri-product__chip', group);
    if (chip) chip.focus({ preventScroll: true });
  }

  function initATC() {
    var form   = qs('#ri-atc-form');
    var msgEl  = qs('#ri-atc-msg');
    var atcBtn = qs('#ri-atc-btn');

    if (!form) return;

    function flash(text) {
      if (!msgEl) return;
      msgEl.textContent = text;
      setTimeout(function () { msgEl.textContent = ''; }, 4000);
    }

    function restore() {
      if (!atcBtn) return;
      atcBtn.disabled = false;
      atcBtn.textContent = atcBtn.dataset.labelAdd;
    }

    /* Fix: same bfcache back-navigation issue as Buy Now — make sure "Adding…"
       never stays stuck on the button if the page is restored from cache. */
    if (atcBtn) {
      window.addEventListener('pageshow', function () {
        if (atcBtn.textContent.trim() === ADDING_LABEL) restore();
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var items = cartItems();
      if (!items) {
        /* Enter in the qty field, or a stale sticky bar - never add without a size */
        if (atcBtn && atcBtn.dataset.state === 'select') {
          flash(atcBtn.dataset.labelSelect);
          focusSizes();
        }
        return;
      }

      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = ADDING_LABEL; }

      postItems(items)
      .then(function () {
        document.dispatchEvent(new CustomEvent('ri:cart:updated'));
        if (msgEl) {
          msgEl.textContent = 'Added to Cart ✦';
          setTimeout(function () { msgEl.textContent = ''; }, 2000);
        }
        restore();
      })
      .catch(function (err) {
        flash((err && err.description) || 'Something went wrong. Please try again.');
        restore();
      });
    });
  }

  /* ─────────────────────────────────────────────
     3b. BUY NOW
  ───────────────────────────────────────────── */
  function initBuyNow() {
    var buyNowBtn = qs('#ri-buy-now-btn');
    if (!buyNowBtn) return;

    var defaultLabel = buyNowBtn.textContent.trim() || 'Buy Now';

    function resetBuyNowButton() {
      var atcBtn = qs('#ri-atc-btn');
      buyNowBtn.disabled = !!atcBtn && atcBtn.dataset.state !== 'add';
      buyNowBtn.textContent = defaultLabel;
    }

    /* Fix: when the shopper clicks Buy Now they navigate to /checkout, and the
       button is left disabled with "Processing…". If they then use the browser
       Back button, most browsers restore this page from the back/forward cache
       (bfcache) instead of reloading it — so that stale state stuck around.
       `pageshow` fires on every load, including bfcache restores, so resetting
       here guarantees the button is always back to normal when the page is shown. */
    window.addEventListener('pageshow', resetBuyNowButton);

    buyNowBtn.addEventListener('click', function () {
      var items = cartItems();
      if (!items) { focusSizes(); return; }

      buyNowBtn.disabled = true;
      buyNowBtn.textContent = 'Processing…';

      postItems(items)
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        var msgEl = qs('#ri-atc-msg');
        if (msgEl && err && err.description) {
          msgEl.textContent = err.description;
          setTimeout(function () { msgEl.textContent = ''; }, 4000);
        }
        resetBuyNowButton();
      });
    });
  }

  /* ─────────────────────────────────────────────
     3c. STICKY ADD TO CART (phones)

     Shown once #ri-atc-btn has scrolled UP out of the viewport, hidden again
     when it comes back. It never keeps state of its own: a MutationObserver
     copies the main button's label, disabled state and data-state, plus the
     price and chosen size, whenever any of them change - including "Adding…".
     Its button submits the real form, so the shawl add-on rides along.

     While it is showing, body.ri-sticky-atc-on lifts the floating WhatsApp
     bubble clear of it (ri-product.css).
  ───────────────────────────────────────────── */
  function initStickyATC() {
    var bar    = qs('#ri-sticky-atc');
    var atcBtn = qs('#ri-atc-btn');
    var form   = qs('#ri-atc-form');
    if (!bar || !atcBtn || !form || !('IntersectionObserver' in window)) return;

    var btn      = qs('[data-sticky-atc]', bar);
    var priceOut = qs('.ri-sticky-atc__price', bar);
    var sizeOut  = qs('[data-sticky-size]', bar);
    var pricing  = qs('.ri-product__pricing');
    var mq       = window.matchMedia('(max-width: 768px)');
    var pastAtc  = false;
    var queued   = false;

    function sync() {
      queued = false;
      var state = atcBtn.dataset.state || 'add';
      btn.textContent = atcBtn.textContent.trim();
      btn.classList.toggle('is-gated', state === 'select');
      /* The gated button stays tappable - it scrolls to the sizes */
      btn.disabled = atcBtn.disabled && state !== 'select';

      var price = qs('.ri-product__price', pricing);
      if (price && priceOut) priceOut.innerHTML = price.innerHTML;

      if (sizeOut) {
        var sizeGroup = qs('.ri-product__option-group--size');
        var chosen = null;
        if (sizeGroup && !sizeGroup.classList.contains('ri-product__option-group--na')) {
          chosen = qs('.ri-product__chip.is-active', sizeGroup);
        } else {
          chosen = qs('.ri-product__option-group--type .ri-product__chip.is-active');
        }
        sizeOut.textContent = chosen ? chosen.textContent.trim() : '';
      }
    }

    /* A microtask rather than requestAnimationFrame: rAF is paused in a
       background tab, and the bar must already be right when the tab returns. */
    function schedule() {
      if (queued) return;
      queued = true;
      Promise.resolve().then(sync);
    }

    function setVisible() {
      var on = pastAtc && mq.matches;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) {
        bar.removeAttribute('inert');
        document.documentElement.style.setProperty('--ri-sticky-atc-h', bar.offsetHeight + 'px');
      } else {
        bar.setAttribute('inert', '');
      }
      document.body.classList.toggle('ri-sticky-atc-on', on);
    }

    new IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      pastAtc = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      setVisible();
    }).observe(atcBtn);

    if (mq.addEventListener) mq.addEventListener('change', setVisible);
    else if (mq.addListener) mq.addListener(setVisible);

    var observer = new MutationObserver(schedule);
    observer.observe(form, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class', 'data-state'] });
    if (pricing) observer.observe(pricing, { subtree: true, childList: true, characterData: true });

    btn.addEventListener('click', function () {
      if (atcBtn.dataset.state === 'select') { focusSizes(); return; }
      if (atcBtn.disabled) return;
      if (form.requestSubmit) form.requestSubmit(atcBtn);
      else atcBtn.click();
    });

    sync();
  }

  /* ─────────────────────────────────────────────
     4. QUANTITY STEPPER
  ───────────────────────────────────────────── */
  function initQty() {
    qsa('.ri-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = qs('.ri-qty-input', btn.closest('.ri-product__qty'));
        if (!input) return;
        var val = parseInt(input.value, 10) || 1;
        if (btn.dataset.action === 'minus') val = Math.max(1,  val - 1);
        if (btn.dataset.action === 'plus')  val = Math.min(99, val + 1);
        input.value = val;
      });
    });
  }

  /* ─────────────────────────────────────────────
     5. WISHLIST
  ───────────────────────────────────────────── */
  function initWishlist() {
    var btn = qs('.ri-product__wishlist');
    if (!btn) return;

    var productDataEl = qs('#ri-product-data');
    if (!productDataEl) return;
    var data;
    try { data = JSON.parse(productDataEl.textContent); } catch (e) { return; }
    var productId     = data.product_id;
    var productHandle = data.product_handle;

    /* Wishlist items are stored as { id, handle } objects so the wishlist
       page can look each product up via /products/{handle}.js. Older
       entries saved before this field existed (plain ids) are dropped
       on next write since they can't be rendered on the wishlist page. */
    var wishlist = [];
    try {
      var raw = JSON.parse(localStorage.getItem('ri-wishlist') || '[]');
      wishlist = raw.filter(function (item) { return item && typeof item === 'object' && item.id; });
    } catch (e) {}

    var svg = qs('path', btn);

    function isWished() {
      return productId && wishlist.some(function (item) { return item.id === productId; });
    }

    function setWished(wished) {
      btn.classList.toggle('is-wished', wished);
      if (svg) svg.style.fill = wished ? 'currentColor' : 'none';
    }

    setWished(isWished());

    btn.addEventListener('click', function () {
      var wished = btn.classList.contains('is-wished');
      if (!wished) {
        if (productId && !isWished()) wishlist.push({ id: productId, handle: productHandle });
      } else {
        wishlist = wishlist.filter(function (item) { return item.id !== productId; });
      }
      try { localStorage.setItem('ri-wishlist', JSON.stringify(wishlist)); } catch (e) {}
      setWished(!wished);
    });
  }

  /* ─────────────────────────────────────────────
     6. SIZE CHART MODAL + FOCUS TRAP
  ───────────────────────────────────────────── */
  function initSizeModal() {
    /* Open triggers */
    qsa('[data-modal]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var modalId = trigger.dataset.modal;
        var modal   = qs('#' + modalId);
        if (!modal) return;
        modal.setAttribute('aria-hidden', 'false');
        modal._trigger = trigger;
        trapFocus(modal);
        /* Unit toggle init */
        initUnitToggle(modal);
      });
    });

    /* Close: button + backdrop + Escape */
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('ri-size-modal__close') ||
          e.target.classList.contains('ri-size-modal__backdrop')) {
        closeModal(e.target.closest('.ri-size-modal'));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var open = qs('.ri-size-modal[aria-hidden="false"]');
        if (open) closeModal(open);
      }
    });
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    if (modal._trigger) modal._trigger.focus();
  }

  function trapFocus(modal) {
    var panel = qs('.ri-size-modal__panel', modal);
    if (!panel) return;
    var focusable = qsa(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      panel
    ).filter(function (el) { return !el.disabled; });
    if (!focusable.length) return;
    focusable[0].focus();

    panel.addEventListener('keydown', function handler(e) {
      if (e.key !== 'Tab') return;
      if (modal.getAttribute('aria-hidden') === 'true') {
        panel.removeEventListener('keydown', handler);
        return;
      }
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
      }
    });
  }

  function initUnitToggle(modal) {
    qsa('.ri-unit-btn', modal).forEach(function (btn) {
      btn.addEventListener('click', function () {
        qsa('.ri-unit-btn', modal).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var unit = btn.dataset.unit;
        qsa('[data-unit-table]', modal).forEach(function (table) {
          table.hidden = table.dataset.unitTable !== unit;
        });
      });
    });
  }

  /* ─────────────────────────────────────────────
     7. DRAG TO SCROLL (Complete the Look / You May Also Love)
     Momentum-based drag scrolling with 60fps updates
  ───────────────────────────────────────────── */
  function initDragToScroll() {
    var scrollContainers = qsa('.ri-related-scroll');

    scrollContainers.forEach(function (container) {
      var isDown = false;
      var startX;
      var scrollLeft;
      var velocity = 0;
      var lastX = 0;
      var lastTime = 0;
      var rafId = null;
      var isMomentumScrolling = false;

      // Cancel any ongoing momentum scroll
      function cancelMomentum() {
        if (rafId) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
        isMomentumScrolling = false;
      }

      // Momentum scroll animation
      function momentumScroll() {
        if (Math.abs(velocity) < 0.5) {
          isMomentumScrolling = false;
          return;
        }

        container.scrollLeft += velocity;
        velocity *= 0.95; // Friction factor

        rafId = requestAnimationFrame(momentumScroll);
      }

      container.addEventListener('mousedown', function (e) {
        cancelMomentum();
        isDown = true;
        container.classList.add('is-dragging');
        startX = e.pageX;
        scrollLeft = container.scrollLeft;
        lastX = e.pageX;
        lastTime = Date.now();
        velocity = 0;
        e.preventDefault();
      });

      container.addEventListener('mouseleave', function () {
        if (isDown) {
          isDown = false;
          container.classList.remove('is-dragging');
          // Start momentum on release
          if (Math.abs(velocity) > 2) {
            isMomentumScrolling = true;
            rafId = requestAnimationFrame(momentumScroll);
          }
        }
      });

      container.addEventListener('mouseup', function () {
        if (isDown) {
          isDown = false;
          container.classList.remove('is-dragging');
          // Start momentum on release
          if (Math.abs(velocity) > 2) {
            isMomentumScrolling = true;
            rafId = requestAnimationFrame(momentumScroll);
          }
        }
      });

      container.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();

        var currentX = e.pageX;
        var currentTime = Date.now();
        var deltaX = currentX - startX;

        // Calculate velocity for momentum
        var timeDelta = currentTime - lastTime;
        if (timeDelta > 0) {
          velocity = (currentX - lastX) / timeDelta * 16; // Scale to ~60fps
        }

        container.scrollLeft = scrollLeft - deltaX;

        lastX = currentX;
        lastTime = currentTime;
      });

      // Prevent default drag behavior on images
      qsa('img', container).forEach(function (img) {
        img.addEventListener('dragstart', function (e) {
          e.preventDefault();
        });
      });

      // Stop momentum if user interacts again
      container.addEventListener('wheel', cancelMomentum);
      container.addEventListener('touchstart', cancelMomentum);
    });
  }


})();
